<template>

<div class="block" v-loading.fullscreen.lock="loading">
    <subHeader
        :title="service.title"
        :subtitle="service.description"
        :img_header="service.img" />

    <div class="container px-4" style="margin-top:130px;">
        <div class="row">
            <div class="col-sm-3 d-none d-md-block">
                <steps :step="step_current" :steps="steps_collection"></steps>
            </div>

            <div class="col-sm-5" v-if="info.status">
                <ClubPark v-if="step_current == 0"
                    :label="'Selecciona un club zonal'"
                    :listSeats="listSeats"
                    @resClub="resClub" />

                <Tickets v-if="step_current == 1"
                    :club="seat"
                    @resVolver="resVolver"
                    @resCarrito="resCarrito" />

               <Facturacion v-if="step_current == 2"
                :abonado="{}"
                @resFact="resFact"
                @resVolver="resVolver" />

            </div>

            <div v-else class="col-sm-5 border-right">
              <el-alert :title="info.message" type="error" effect="dark" :closable="false" />
            </div>

            <div class="col-sm-4">
              <Resumen></Resumen>
            </div>
        </div>
    </div>
</div>
</template>

<script>
//components
import subHeader from "@/components/common/subHeader";
import steps from "@/components/common/Steps";
import ClubPark from "@/components/common/ClubPark";
import Tickets from "./Tickets"
import Facturacion from "@/components/pages/abonados/Facturacion";
import Resumen from "./Resumen"

//services
import services from "@/services/services.service";
import moment from "moment";

import { mapGetters } from 'vuex'

export default {
    components: {
        subHeader,
        steps,
        ClubPark,
        Tickets,
        Resumen,
        Facturacion
    },
    data: () => ({
        loading: false,
        info: {},
        service: {},
        step_current: 0,
        steps_collection: [],
        listSeats: [],
        seat: {},
        carrito: [],
        form: {}
    }),
    mounted() {
        this.init();
    },
    created() {
        this.$store.dispatch("updateSubRouter", true);
    },
    computed: {
      ...mapGetters(['totalPagar', 'getDateVisit'])

    },
    methods: {
        showError(message) {
            this.$alert(message, "Aviso", {
                confirmButtonText: "Entendido",
                type: "warning",
                center: true,
            });
        },
        async init() {
            this.loading = true;
            this.steps_collection = [];
            await services
                .get("parking")
                .then((res) => {
                    this.info = res.data
                    this.service = res.data.details;
                    this.steps_collection = JSON.parse(res.data.details.steps);
                    axios
                        .post(`${process.env.API2}/v1/as/busquedaxareaxgeneral/1`)
                        .then((res) => {
                            //console.log(res.data)
                            if (res.data.length > 0) {
                                const tmp = res.data.map((item) => {
                                    return {
                                        idseat: item.codigoArea,
                                        name: item.areaDescripcion,
                                        city: item.distrito,
                                        address: item.direccion,
                                        latitud: item.latitud,
                                        longitud: item.longitud,
                                        imagenUrl: item.imagenUrl
                                    };
                                });
                                this.listSeats = tmp;
                            }
                            //console.log(this.listSeats);
                        });
                })
                .catch((err) => {
                    this.loading = false;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        resVolver(step) {
            this.$store.dispatch("updateDateVisit", '');
            this.$store.dispatch("updateCarrito", []);
            this.step_current = step - 1
        },
        resClub(club) {
            this.seat = club;
            this.step_current++;
        },
        resCarrito(data) {
            this.carrito = data;
            this.step_current++;
        },
        saveVentaSPV() {
            this.loading = true
            //console.log(this.getDateVisit)
            let fecha = this.getDateVisit.split('/');
            let fecha2 = fecha[2] + '-' + fecha[1] + '-' + fecha[0];
            let date_visit = moment(fecha2).format("YYYY-MM-DD[T]HH:mm:ss")
            //let fecha = this.getDateVisit.split(/[-/]/).reverse().join("-");
            //console.log(fecha2)
            //console.log(moment(fecha2).format("YYYY-MM-DD[T]HH:mm:ss"))
            axios
                .post(`${process.env.API2}/v1/reserva/registroGeneral`, {
                    cabeceraParameter: {
                        ue: "001066",
                        sede: "001",
                        codigoVenta: "",
                        fechaEmision: moment(date_visit).format("YYYY-MM-DD[T]HH:mm:ss"),
                        tipoSistema: "ART",
                        areaId: this.form.st0.idseat,
                        tipoDocumentoId: this.form.st2.voucher,
                        docNumero: this.form.st2.fndoc,
                        nombre: this.form.st2.fname,
                        total: this.totalPagar
                    },
                    cuerpoParameters: this.carrito
                })
                .then((res) => {
                    this.loading = false;
                    //alert(res.data)
                    if (parseInt(res.data) > 0) {
                        this.form.operation = parseInt(res.data);
                        this.form.date_visit = this.getDateVisit
                        axios
                            .post(`${process.env.API1}/api/entradas/register`, this.form)
                            .then((response) => {
                                this.loading = false;
                                if (response.data.status)
                                    window.location.href = response.data.url;
                                else alert(response.data.message);
                            })
                            .catch((err) => {
                                this.loading = false;
                            });

                    } else {
                        this.loading = false;
                        this.showError("Lo sentimos, no se ha podido registrar la información.");
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        resFact(data) {
            this.$confirm('Está a punto de ir con el proceso de pago, desea continuar?', 'info', {
                confirmButtonText: 'si, continuar',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(() => {
                this.form.st0 = this.seat;
                this.form.st1 = this.carrito;
                this.form.st2 = data
                this.saveVentaSPV()
            }).catch(() => {});
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/parking/Index.vue